<template>
  <div class="row">
    <div class="col-md-4 mb-2">
      <label class="form-label">Поиск по товарам</label>
      <input type="text" class="form-control border-1 py-2" placeholder="Название, код товара, бренд"
        v-model="searchData.name" @input="updateProducts">
    </div>
  </div>

  <ProductsListSimple ref="ProductsList" :filters="debouncedFilters" :with_checkbox="true"
    @selection-changed="updateSelectedProducts" />
  <div class="d-flex justify-content-start mt-4">
    <button class="btn btn-primary" @click="saveSelectedProducts" :disabled="selected_product_ids.length === 0">
      Добавить выбранные товары ({{ selected_product_ids.length }})
    </button>
  </div>
</template>

<script>
import ProductsListSimple from "@/components/strategy/ProductsListSimple.vue";

export default {
  name: 'ProductsChoose',
  components: { ProductsListSimple },
  data() {
    return {
      selected_product_ids: [],
      searchData: {
        name: '',
      },
      debouncedFilters: {
        name: '',
      },
      debounceTimeout: null
    }
  },

  methods: {
    updateProducts() {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      
      this.debounceTimeout = setTimeout(() => {
        this.debouncedFilters = { ...this.searchData };
      }, 800);
    },
    saveSelectedProducts() {
      this.$emit('products-selected', this.selected_product_ids)
      this.selected_product_ids = []
      this.searchData = { name: '' }
      this.debouncedFilters = { name: '' }
      this.$refs.ProductsList.reset()
    },
    updateSelectedProducts(selectedIds) {
      this.selected_product_ids = selectedIds
    }

  },
  emits: ['products-selected'],
}
</script>